<template>
  <div class="dialog-body">
    <el-dialog
      v-if="dialogVisible"
      title="仓储合同主体变更提示"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
    >
      <div class="result">
        <el-row :gutter="24">
          <el-col :span="24">
            <span style="text-align: center; display: block"
              >变更主体必须关闭该合同，重新创建合同是否关闭该合同?</span
            >
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSure">关闭合同</el-button>
        <el-button @click="handleClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'changeSubjectDialog',
    props: ['row'],
    data() {
      return {
        dialogVisible: false,
        id: null,
      };
    },
    methods: {
      openDialog() {
        this.dialogVisible = true;
      },
      handleClose() {
        this.dialogVisible = false;
      },
      handleSure() {
        this.dialogVisible = false;
        let path = {
          path: 'warehouse/contractClose',
          name: 'contractClose',
          meta: {
            keepAlive: true,
            title: '合同关闭',
          },
          query: {
            id: this.id,
            pageMode: 5,
          },
        };
        this.$router.push(path);
      },
    },
    watch: {
      row: {
        handler(val) {
          this.id = val;
          console.log(this.id, 'id值');
        },
        immediate: false,
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .result {
    padding: 20px 100px 20px 100px;
  }

  ::v-deep .el-dialog__footer {
    text-align: center;
  }
</style>
